import React from 'react';

import { NavLink } from 'react-router-dom';

export default function LinkElement({ link }) {
  /* const [isSubListVisible, setIsSubListVisible] = useState(true); */

  return (
    <>
      <NavLink
        end
        aria-controls="dropdown-sales"
        data-collapse-toggle="dropdown-sales"
        to={link.url}
        //  onClick={() => setIsSubListVisible((prevState) => !prevState)}
        className={({ isActive }) =>
          isActive
            ? 'flex items-center justify-between p-2 text-base font-medium text-gray-900 dark:text-white rounded-lg bg-gray-100 dark:bg-gray-700 group'
            : 'flex items-center justify-between p-2 text-base font-medium text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
        }
      >
        {link.title}
        {/*  {link.links && link.links.length > 0 && (
          <svg
            className={classNames('w-6 h-6', {
              'rotate-180': isSubListVisible,
              'transition-transform duration-200': true,
            })}
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            ></path>
          </svg>
        )} */}
      </NavLink>
      {link.links && link.links.length > 0 && (
        <ul id="dropdown-sales" className="py-2 space-y-2">
          {link.links.map((subLink) => {
            return (
              <li key={subLink.url}>
                <NavLink
                  to={subLink.url}
                  className={({ isActive }) =>
                    isActive
                      ? 'flex items-center p-2 pl-11 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700 text-gray-900 dark:text-white rounded-lg bg-gray-100 dark:bg-gray-700'
                      : 'flex items-center p-2 pl-11 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700'
                  }
                >
                  {subLink.title}
                </NavLink>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
}
